import { IMainDirectoryListItem } from '../../graphql/useAllMainDirectoryListQuery';

export interface IState {
    activeView: IMainDirectoryListItem;
    isPickerOpen: boolean;
    favouriteViews: IMainDirectoryListItem[];
}

export type ReducerAction =
    | { type: 'closePicker' }
    | { type: 'openPicker' }
    | { type: 'togglePicker' }
    | { type: 'updateView'; payload: IMainDirectoryListItem }
    | { type: 'updateFavourites'; payload: IMainDirectoryListItem };

export { ViewPicker } from './ViewPicker';
